import { render } from "./ToggleList.vue?vue&type=template&id=71a58d14"
import script from "./ToggleList.vue?vue&type=script&lang=js"
export * from "./ToggleList.vue?vue&type=script&lang=js"

import exportComponent from "/browser/CARTaGENE_vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__